const siteConfig = {
    title: "Adithya Saish",
    description: "Personal website and portfolio",
    author: "Adithya Saish",
    links: {
        github: "https://github.com/dadisahis",
        linkedin: "https://linkedin.com/in/adithya-saish-445506194",
        leetcode: "https://leetcode.com/u/dadi_sahis99/",
        email: "mailto:adithya.work99@gmail.com"
    },
    sections: [
        { id: "about", title: "About" },
        { id: "projects", title: "Projects" },
        { id: "blog", title: "Blog" }
    ]
};

export default siteConfig;
